import React from "react";

const Layout = ({ children }) => {
  return (
    // Main layout wrapper - responsive container for all pages
    // Mobile: centered, compact padding
    // Tablet: normal spacing
    // Desktop: full width with optimal spacing
    <main className='flex flex-col overflow-hidden w-full h-full'>
      {children}
    </main>
  );
};

export default Layout;
